import { getCountryField, getCountryFieldLayout } from '@wix/form-multiline-address';
import { addFieldToSchema, generateUUID } from '@wix/form-schema';
import { useMemo, useState } from 'react';
import { EXPERIMENTS, FIELD_TYPES } from '../../../constants';
import { useAddressForms } from '../../../contexts/address-forms-context';
import { useConfig } from '../../../contexts/config-context';
import { useExperiments } from '../../../contexts/experiments-context';
import { createFormView } from '../../../services/form-view';
import { applyMultilineAddressSettings } from '../../../utils/apply-multiline-address-settings';
import { overrideFieldIds } from '../../../utils/field-id-overrides';
import { removeGaps } from './remove-gaps';
const createFieldIds = ()=>({
        country: generateUUID(),
        subdivision: generateUUID(),
        city: generateUUID(),
        address_line: generateUUID(),
        address_line_2: generateUUID(),
        postal_code: generateUUID(),
        street_name: generateUUID(),
        street_number: generateUUID(),
        apartment: generateUUID()
    });
export const useMultilineAddressForm = ({ id, target, fieldType, form: hostForm, country, fieldSettings, validation, required })=>{
    const [fieldIds] = useState(createFieldIds);
    const { isExperimentEnabled } = useExperiments();
    const useFieldsV2 = isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2);
    const { getCountryAddressForm } = useAddressForms();
    const { isMobile, breakpoint } = useConfig();
    const template = getCountryAddressForm(country);
    const isMultilineAddressField = fieldType === FIELD_TYPES.MULTILINE_ADDRESS || fieldType === FIELD_TYPES.BOOKINGS_ADDRESS;
    const mlaCountryField = useMemo(()=>getCountryField(required, validation?.predefined?.multilineAddressOptions), [
        validation,
        required
    ]);
    const mlaCountryLayout = useMemo(()=>getCountryFieldLayout(), []);
    const form = useMemo(()=>{
        if (!isMultilineAddressField || !template) {
            return hostForm && {
                ...hostForm,
                fields: overrideFieldIds(hostForm.fields, fieldIds)
            };
        }
        const baseForm = createFormView({
            useFieldsV2,
            path: target,
            parentId: id,
            includeHiddenFields: true,
            isMobile,
            breakpoint,
            form: applyMultilineAddressSettings(addFieldToSchema(template, mlaCountryField, mlaCountryLayout), fieldSettings, validation?.predefined?.multilineAddressOptions?.fields)
        });
        const hasHiddenFields = baseForm.fields.some((field)=>field.properties.hidden);
        if (!hasHiddenFields) {
            return baseForm;
        }
        const formWithoutGaps = removeGaps(baseForm);
        return {
            ...formWithoutGaps,
            fields: formWithoutGaps.fields.filter((field)=>!field.properties.hidden)
        };
    }, [
        template,
        hostForm,
        fieldIds,
        fieldSettings,
        validation,
        target,
        mlaCountryField,
        mlaCountryLayout,
        isMultilineAddressField,
        useFieldsV2,
        id,
        isMobile,
        breakpoint
    ]);
    return {
        form,
        isMultilineAddressField
    };
};

//# sourceMappingURL=use-multiline-address-form.js.map